// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"77b321ac","282":"0a6c931d","707":"19033af9","963":"12d02e6d"}[chunkId] + ".chunk.js";
};